import { motion, useReducedMotion } from "framer-motion";

export const GraffitiTag = ({
  children,
  className = "",
  color = "text-gold",
  delay = 0.2,
  rotate = -4,
  watermark = false,
  testId,
}) => {
  const reduce = useReducedMotion();
  return (
    <motion.span
      data-testid={testId}
      initial={{ opacity: 0, scale: 0.6, rotate: rotate * 2.5 }}
      whileInView={{ opacity: watermark ? 0.06 : 1, scale: 1, rotate }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay, type: "spring", stiffness: 220, damping: 12 }}
      className={`${className}`}
    >
      <motion.span
        animate={reduce ? {} : { y: [0, -7, 0] }}
        transition={reduce ? {} : { duration: 4.5, repeat: Infinity, ease: "easeInOut", delay }}
        className={`font-graffiti inline-block whitespace-nowrap ${watermark ? "" : "graffiti-glow"} ${color}`}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};
